var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0582 12.5C20.0582 12.8082 19.8083 13.0581 19.5 13.0581L5.50003 13.0581C5.19177 13.0581 4.94189 12.8082 4.94189 12.5C4.94189 12.1917 5.19177 11.9418 5.50003 11.9418L19.5 11.9418C19.8083 11.9418 20.0582 12.1917 20.0582 12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8947 19.8946C12.6767 20.1126 12.3233 20.1126 12.1054 19.8946L5.10536 12.8946C4.88739 12.6767 4.88739 12.3233 5.10536 12.1053L12.1054 5.1053C12.3233 4.88733 12.6767 4.88733 12.8947 5.1053C13.1127 5.32327 13.1127 5.67666 12.8947 5.89463L6.28935 12.5L12.8947 19.1053C13.1127 19.3233 13.1127 19.6767 12.8947 19.8946Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.7bfd48d1c4cb4f722b18aa969ee2af6a.svg";
export { ForwardRef as ReactComponent };